import { Card } from "@/components/ui/card";
import { usd } from "./affiliateFormat";

const Stat = ({ label, value, hint, testId, accent }) => (
  <Card className="bg-black/40 border border-white/10 p-4">
    <p className="text-[11px] uppercase tracking-widest text-gray-400 font-bold">{label}</p>
    <p className={`text-2xl sm:text-3xl font-black mt-1 ${accent || "text-white"}`} data-testid={testId}>{value}</p>
    {hint && <p className="text-[11px] text-gray-500 mt-1">{hint}</p>}
  </Card>
);

export const AffiliateStats = ({ stats, holdDays }) => (
  <div className="grid grid-cols-2 lg:grid-cols-3 gap-3" data-testid="affiliate-stats">
    <Stat label="Link clicks" value={stats.clicks} testId="affiliate-stat-clicks" />
    <Stat label="Signups" value={stats.signups} testId="affiliate-stat-signups" />
    <Stat label="Paid conversions" value={stats.paid_conversions} testId="affiliate-stat-conversions" />
    <Stat label="Pending earnings" value={usd(stats.pending_cents)} hint={`Held ${holdDays} days after payment`}
      testId="affiliate-stat-pending" accent="text-amber-200" />
    <Stat label="Available earnings" value={usd(stats.available_cents)} hint="Ready to request"
      testId="affiliate-stat-available" accent={stats.available_cents < 0 ? "text-rose-300" : "text-emerald-300"} />
    <Stat label="Paid out" value={usd(stats.paid_out_cents)} hint={stats.in_payout_cents ? `${usd(stats.in_payout_cents)} in review` : null}
      testId="affiliate-stat-paid" />
  </div>
);
